export enum Languages {
  FR_FR = "Français (France)",
  /*EN_US = "English (US)",*/
}

export enum Languages_MIN {
  FR_FR = "FR",
  /*EN_US = "EN",*/
}

export const INVERTED_Languages_MIN = Object.fromEntries(
  Object.entries(Languages_MIN).map(([key, value]) => [value.toLowerCase(), key]),
);

export const LOCALES = ["fr" /*, "en"*/];

export enum Locales {
  FR_FR = "fr",
  /*EN_US = "en",*/
}

export const DEFAULT_LOCALE = LOCALES[0];
export const DEFAULT_LANGUAGE: keyof Languages = "FR_FR" as keyof Languages;

export function languagesObject(): { [key: string]: string } {
  const obj: { [key: string]: string } = {};

  Object.keys(Languages).forEach((key) => {
    // @ts-expect-error
    obj[key] = Languages[key];
  });

  return obj;
}

export function getLanguageParam(lang: string): string {
  let _lang: any = INVERTED_Languages_MIN[lang];

  if (!lang) {
    _lang = DEFAULT_LANGUAGE;
  }

  return `?language=${_lang}`;
}
